import {Chip, Icon} from '@ezcater/tapas';
import {type IconDefinition} from '@fortawesome/pro-regular-svg-icons';
import {twMerge} from 'tailwind-merge';

type ContactChannelProps = {
  icon: IconDefinition;
  action: React.ReactNode;
  className?: string;
  description?: string;
  recommendedLabel?: string;
  children?: React.ReactNode;
};

const ContactChannel: React.FC<ContactChannelProps> = ({
  icon,
  action,
  className,
  description,
  recommendedLabel,
  children,
}) => (
  <div className={twMerge('flex items-start gap-4', className)}>
    <span className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-peppercorn-50">
      <Icon aria-hidden className="text-peppercorn-800" icon={icon} size="small" />
    </span>
    <div className="flex flex-col gap-1">
      <div className="flex flex-wrap items-center gap-2">
        {action}
        {recommendedLabel && <Chip variant="info">{recommendedLabel}</Chip>}
      </div>
      {description && <p className="text-sm text-black">{description}</p>}
      {children}
    </div>
  </div>
);

export default ContactChannel;
